'use client';

import { c as _c } from "react/compiler-runtime";
import { useDecisions } from '../../../hooks';
import { useMedalliaForm } from './use-medallia-form';
import { useMedalliaFormV2 } from './use-medallia-form-v2';
export function useMedalliaFeedback() {
  const $ = _c(4);
  const isOneTrust = useDecisions("onetrust");
  const t0 = !isOneTrust;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      isActive: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const legacyForm = useMedalliaForm(t1);
  let t2;
  if ($[2] !== isOneTrust) {
    t2 = {
      isActive: isOneTrust
    };
    $[2] = isOneTrust;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formV2 = useMedalliaFormV2(t2);
  return isOneTrust ? formV2 : legacyForm;
}